import React from "react";
import TextAccordion from "./textAccordion";

const TextAccordionList = ({ accordionList, containerClass }) => {
  return (
    <>
      {accordionList && accordionList?.length > 0 && (
        <div className={containerClass}>
          <div className="w-11/12 md:w-9/12 pt-20 pb-12 mx-auto">
            <div className="overflow-auto md:pr-11 md:gvi-scrollbar-thin md:max-h-114">
              {accordionList.map((item, index) => (
                <TextAccordion data={item} key={index} />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TextAccordionList;

TextAccordionList.defaultProps = {
  containerClass: "w-full flex bg-white dark:bg-gray-darkest"
};
